<!-- this component is to determine how weak / strong a password and display a meter -->

<template>

    <div class="col-12">
        <div v-if="uiOverride" ref="progresscontainer" class="pwstrength_viewport_progress"></div>
    </div>

</template>

<script>

    import $ from 'jquery';
    import 'pwstrength-bootstrap/dist/pwstrength-bootstrap.js';

    export default {
        name: 'password-strength-component',
        props: ['passwordelementjqueryselector', 'validationpattern', 'uiOverride'],
        mounted: function () {

            let uiToUse = this.uiOverride ?
                this.uiOverride :
                {
                    bootstrap4: true,
                    container: $(this.$el),
                    viewports: {
                        progress: $(this.$refs.progresscontainer)
                    },
                    showVerdictsInsideProgressBar: true
                };


            // Here is how you can configure options: https://github.com/ablanco/jquery.pwstrength.bootstrap/blob/master/OPTIONS.md
            $(this.passwordelementjqueryselector).pwstrength({
                common: {
                    usernameField: null
                },

                ui: uiToUse,

                common: {
                    onKeyUp: (evt, data) => {
                        this.$emit('on-score-change', data);
                    }
                },

                //this is a custom callback we added to the plug in. Check pwstrength-bootstrap-1.2.7.js when upgrading the library. Couldn't find a good way to inject a callback that isn't there
                //i later added a pull request and and it got accepted. if you update the library then just use the updated code with the pull request
                //https://github.com/ablanco/jquery.pwstrength.bootstrap/issues/103
                TotalScoreCallbackAdjustment: (totalTallyScore, word) => {

                    //if we don't have a valid password then make it less then 27
                    if (!word.match(this.validationpattern) && totalTallyScore > 26) {
                        return 25;
                    }

                    //check to make sure we have 8 characters and 1 digit and 1 alpha atleast
                    if (word.length >= 8 && word.match(/([a-zA-Z])/) && word.match(/([0-9])/)) {

                        //if the score is less then 27. 27 is the least amount of points for 'good'
                        if (totalTallyScore <= 27) {
                            //just return the min amount
                            return 27;
                        }
                    }

                    //otherwise just return whatever was tallied up
                    return totalTallyScore;
                }
            });
        }
    };
</script>
